import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ui from 'redux-ui';
import './InteractiveLayer.css';
import Canvas from '../canvas/Canvas';

class InteractiveLayer extends Component {
  constructor(props) {
    super(props);
    this.layerRef = '';
  }

  render() {
    const {
      placeholders,
      lang,
      backgroundImage,
      backgroundPlaceholders,
    } = this.props;


    const style = {
      backgroundImage: backgroundImage !== '' ? `url(${encodeURI(backgroundImage)})` : '',
    };

    return (

      <div
        ref={(layerRef) => { this.layerRef = layerRef; }}
        className="InteractiveLayer"
        style={style}
      >
        <Canvas
          placeholders={placeholders}
          lang={lang}
          backgroundPlaceholders={backgroundPlaceholders}
        />
      </div>
    );
  }
}

InteractiveLayer.defaultProps = {
  placeholders: [],
  lang: {},
  backgroundImage: '',
};

InteractiveLayer.propTypes = {
  placeholders: PropTypes.array,
  lang: PropTypes.object,
  backgroundImage: PropTypes.string,
};

export default ui({
  key: 'EditorToolsUI',
  state: {
    marginType: '',
  },
})(InteractiveLayer);



// WEBPACK FOOTER //
// ./src/components/interactive-layer/InteractiveLayer.jsx